/** Backend API origin — set REACT_APP_API_URL in .env (see .env.example). */
export function getApiBaseUrl(): string {
  const raw = process.env.REACT_APP_API_URL?.trim() || 'https://api.multybed.com';
  return raw.replace(/\/$/, '');
}

export const API_BASE_URL = getApiBaseUrl();
